function Diploma(props) {

    const {data} = props

    return (
        <a className="Diploma" href={data.pdf} target="_blank" rel="noreferrer">
            <img src={data.img} alt='' data-aos="zoom-in" data-aos-duration='2000'/>
            <p data-aos="fade-zoom-in" data-aos-delay='500' data-aos-duration='1500'>{props.language === props.uk ? data.name : data.nameEs}</p>
        </a>
    )
}
export default Diploma